import { apiSignin } from "../../../api";
import { loginFail, loginSuccess, prepareNewSession, setAuthenticatedUser } from "../actions/authActions";
import { put, call } from "redux-saga/effects";
import { updateUser } from "../actions/userActions";
import Swal from 'sweetalert2';
import {clearSession, saveSession} from "../../utils/tokenStorage";

export function* loginSaga(action) {
    try {
        const username = String(action.payload.username || "");
        const password = String(action.payload.password);
        const response = yield call(apiSignin, username, password);

        const responseData = response.data;

        const userData = responseData?.user || responseData;
        const token = responseData?.token;
        const rememberMe = action.payload?.rememberMe ?? false;

        if (token) {
            prepareNewSession();
            saveSession(
                {
                    token,
                    email: userData?.username || userData?.email || username,
                    uid: userData?.id,
                },
                rememberMe
            );
        }

        if (userData) {
            localStorage.setItem('user', JSON.stringify(userData));
        }

        yield put(loginSuccess(responseData));
        yield put(setAuthenticatedUser(userData));
        yield put(updateUser(userData));

    } catch (error) {
        const status = error?.response?.status;
        const errorData = error?.response?.data;

        let errorMessage = 'Une erreur est survenue';
        let errorTitle = 'Erreur de connexion';

        if (status >= 500) {
            errorMessage = errorData?.message || 'Erreur serveur. Réessayez plus tard.';
            errorTitle = 'Erreur serveur';
        } else if (status === 401 || status === 400) {
            errorMessage = errorData?.message || 'Identifiants incorrects';
            errorTitle = 'Identifiants incorrects';
        }

        Swal.fire({
            icon: 'error',
            title: errorTitle,
            text: errorMessage,
            confirmButtonText: 'Réessayer',
            confirmButtonColor: '#d33'
        });

        yield put(loginFail({
            message: errorMessage,
            status: status,
            details: errorData
        }));
    }
}

export function* logoutSaga() {
    try {
        clearSession();
        localStorage.removeItem('user');
    } catch (error) {
        console.error('Logout error:', error);
    }
}
